export default __webpack_public_path__ + "src/images/about/Resources-922c4561eca7da3b267aaadec9dd7031.png";